<template>
  <router-view/>
</template>

<script>
import { setupCrossTabListener, checkAuthStatus } from '@/utils/auth';

export default {
  name: 'App',
  
  created() {
    /**
     * 应用初始化时的关键步骤：
     * 
     * 1. 检查登录状态（目前已注释）
     * 每个标签页启动时都会检查当前的登录状态
     */
    checkAuthStatus(this.$store);

    /**
     * 2. 注册跨标签页通信监听器
     * - 在每个标签页启动时都会注册这个监听器
     * - 监听其他标签页对 LocalStorage 的修改
     * - 自动同步登录状态，确保所有标签页的登录状态一致
     */
    setupCrossTabListener(this.$store);

    /**
     * 3. 页面关闭时的清理（目前已注释）
     * 清除当前标签页的会话标记，避免影响其他标签页
     */
    // window.addEventListener('beforeunload', () => {
    //   sessionStorage.removeItem('auth-session-marker');
    // });
  }
}
</script>
